import { render } from "./payment-orders.vue?vue&type=template&id=3e73d2dd&scoped=true"
import script from "./payment-orders.vue?vue&type=script&lang=js"
export * from "./payment-orders.vue?vue&type=script&lang=js"

import "./payment-orders.vue?vue&type=style&index=0&id=3e73d2dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e73d2dd"]])

export default __exports__